<template>
  <div data-app>
      <router-view/>
  </div>
</template>
<script>
  // import WaitingModal from '@/components/WaitingModal'

  export default {
    components: {

    },
    computed: {
      isLogin() {
        return this.$route.name === 'login'
      }
    },
  }
</script>
<style lang="scss">
    @import '../public/sass/main.scss';
</style>

